
export default {
  getCurrentCampaign (state) {
    return state.currentCampaign
  }
}
